/**
 * axios 환경 설정
 */
import axios from 'axios';

const config = {};

if (process.env.NODE_ENV === 'development') {
  // TODO: API URL 통합 필요
  // config.baseURL = process.env.REACT_APP_API_URL;
  config.baseURL = process.env.REACT_APP_API_URL_SFSH;
}

export default axios.create(config);
